import React, { useState } from 'react'
import { Typography } from '@mui/material'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { useApi } from '../../../hooks/useApi'
import { t } from '../../../intl/resources'
import { Loading } from '../../../components/UI/Loading/Loading'
import { Status } from '../../../hooks/useFetchState'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface DeleteWorkOrderModalProps {
  deleteWorkOrderModalState: ModalReturnType<{
    workOrderId: number
  }>
  handleSnackbarNotification: (msg: string | undefined, status: boolean) => void
  handleRequestWorkOrders: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

const deleteWorkOrderApi = (workOrderId: number) => {
  const url = new URL(`${ApiConfig.WorkOrderApi}/${workOrderId}`)

  return axios.delete(url.toString())
}

export const DeleteWorkOrderModal: React.FC<DeleteWorkOrderModalProps> = ({
  deleteWorkOrderModalState,
  handleSnackbarNotification,
  handleRequestWorkOrders
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { state, callApi } = useApi()

  const requesteRemoveWorkOrder = (workOrderId: number) => {
    setLoading(true)

    callApi(deleteWorkOrderApi(workOrderId))
      .then(() =>
        handleSnackbarNotification(
          'Orden de Trabajo eliminada correctamente',
          true
        )
      )
      .catch((err) => handleSnackbarNotification(err, false))
      .finally(() => {
        handleRequestWorkOrders()
        deleteWorkOrderModalState.closeModal()
      })

    setLoading(false)
  }

  const message = deleteWorkOrderModalState.extendedProps?.workOrderId
    ? `¿Está seguro que desea eliminar la orden de trabajo
  ${deleteWorkOrderModalState.extendedProps?.workOrderId}?`
    : 'No se ha seleccionado Orden de Trabajo para eliminar.'

  return (
    <Modal
      open={deleteWorkOrderModalState.isOpen}
      maxWidth={deleteWorkOrderModalState.size}
      onClose={() => {
        handleRequestWorkOrders()
        deleteWorkOrderModalState.closeModal()
      }}
      title={deleteWorkOrderModalState.title}
      cancelButton={{
        action: () => {
          handleRequestWorkOrders()
          deleteWorkOrderModalState.closeModal()
        },
        title: t('CANCEL'),
        disabled: state.status === Status.Loading || loading
      }}
      successButton={{
        action: () =>
          requesteRemoveWorkOrder(
            deleteWorkOrderModalState.extendedProps?.workOrderId || 0
          ),
        title: t('ACCEPT'),
        disabled: state.status === Status.Loading || loading
      }}
    >
      {state.status === Status.Loading || loading ? (
        <div>
          <Typography>
            <Loading />
          </Typography>
        </div>
      ) : (
        <Typography variant='body2'>{message}</Typography>
      )}
    </Modal>
  )
}
